export const useLayoutState = () => {
  const showMobileSidebar = useState<boolean>('show-mobile-sidebar', () => false)
  const minimalUI = useState<boolean>('minimal-ui', () => false)

  return {
    showMobileSidebar,
    minimalUI
  }
}
